import { FrameBody, Warning, WarningProps} from "@npd-ng/adp-benchmark";
import { Views} from "../types";
import { Content } from "../types/Content";
import { LastStateToViewMap, actions } from "../state";
import { useStateContext } from "../hooks/useStateContext";
import { checkNetworkState } from "../hooks/useNetworkService";
export default function WarningView() {
  const { state, dispatch } = useStateContext();
  console.log('state',state);
  const content= state.staticContent as Content;
  const type = state.deviceReadinessState.validationError || "SystemError";
  const deviceReadiness =content.deviceReadiness[type]
  const lastView: Views = LastStateToViewMap.get(state.sessionState.lastKnownGoodState) as Views
  const actionsContent = content.actions;
  const onAction =()=>{
    const warning = checkNetworkState(state.sessionState.networkConnectionState,state.sessionState.selectedAssessmentMode)
    if(!warning){
      dispatch(actions.createSetViewAction(lastView));
    }
    else {
      dispatch(actions.createSetViewAction("WaitView"));
      setTimeout(()=>{
        const warning = checkNetworkState(state.sessionState.networkConnectionState,state.sessionState.selectedAssessmentMode)
        if(!warning){
          dispatch(actions.createSetViewAction(lastView));
        }
        else {
          dispatch(actions.createSetViewAction("WarningView"));
        }
      },2000);
    }
  }
  const warningProps: WarningProps = {
      errorCode: deviceReadiness.code,
      title: deviceReadiness.title,
      message: deviceReadiness.message,
      buttons:[{
        label: actionsContent.tryAgain,
        action:onAction,
        variant: "primary"
    },{
          label: actionsContent.cancel,
          action:()=>{dispatch(actions.createSetViewAction("ModeSelectionsView"))},
          variant: "secondary"
      }, ]
    }
  return (
    <>
       <FrameBody>
          <Warning {...warningProps}/>
       </FrameBody>

    </>
  )
}
